<template>
    <div class="row"  id="resetPassword">
        <div class="login_box">
            <div class="login_image_container">
                <img src="../assets/images/clockit_login.png" class="login_image" />
            </div>

            <div class="login_form_container">
                <form action="#" @submit.prevent="submitHandler">
                    <center>
                        <h4>{{ title }}</h4>
                    </center>
                    <br />
                    <div class="form-group"  v-if="!this.isSuccess">
                        <input type="password" class="form-control" placeholder="New Password" v-model="newPassword">
                    </div>

                    <div class="form-group"  v-if="!this.isSuccess">
                        <input type="password" class="form-control" placeholder="Confirm New Password" v-model="confirmPassword">
                    </div>

                    <div class="form-group">
                        <span v-if="this.errormsg" align="center"><p class="text-danger">{{ errormsg }}</p></span>
                        <span v-if="this.okmsg" align="center"><p class="text-primary">{{ okmsg }}</p></span>
                    </div>

                    <div class="form-group">
                        <center>
                            <button v-if="!this.isSuccess" type="submit" class="btn btn-primary">SUBMIT</button>
                            <router-link :to="`/${$i18n.locale}/`"><button class="btn btn-danger">BACK TO LOGIN</button></router-link>
                        </center>
                    </div>
                </form>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
//import {configdata} from '../../static/config';

export default {

    data () {
        return {
            email: '',
            title: 'RESET PASSWORD',
            newPassword: '',
            confirmPassword: '',
            auth: false,
            errormsg: null,
            okmsg: null,
            isSuccess: false,
            token: this.$route.params.token,
        }
    },

    methods: {
        submitHandler() {
            if (this.confirmPassword !== this.newPassword) {
                this.errormsg = "Password mismatch. Please try again"
            } else {
                const vm = this;
                //let rootAPI = configdata.ROOT_API
                axios.put(`${this.$store.getters.rootAPI}/admin/resettingpassword` , {
                    email: vm.email,
                    password: vm.newPassword
                })
                .then (function (response) {
                    //console.log(response)
                    vm.okmsg = "Reset Successful"
                    vm.errormsg = null;
                    vm.isSuccess = true
                })
                .catch(function (error) {
                    console.log(error);
                })
            }
        },

        checkAuth() {
            const vm = this
            var AuthStr = 'Bearer ' + this.token
            //var AuthStr = 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoic3RhbmxleUB0cmFuc2FjdDIuY29tIiwiaWF0IjoxNTU5ODc5MzgyLCJleHAiOjE1NjAwNTIxODJ9.IVIFFzOTJLLo1h_VGQpTsughZ4Tdhz160uKj2ANUcF'

            axios.get(this.$store.getters.rootAPI + '/admin/isresetpassword', { headers: { Authorization: AuthStr }})
            .then(function (response) {
                if (response.status === 200) {
                    let jwtCode = require('jwt-decode')

                    var decoded = jwtCode(vm.token);
                    vm.email = decoded.data;

                    vm.auth = true
                }
            })
            .catch(function (error) {
                vm.errormsg = 'Authentication failed';
                alert(vm.errormsg);
                vm.$router.push('/login')
            })
        },


        init() {
          setTimeout(() => {
            this.checkAuth();
          }, 1000);
        }
    },

    mounted() {
        this.init();
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue